import { render, staticRenderFns } from "./BaseTab.vue?vue&type=template&id=d4d908ea&"
import script from "./BaseTab.vue?vue&type=script&lang=js&"
export * from "./BaseTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports